/**
 * Global atom for queuing SQL filter commands from agent tools.
 *
 * Agent tools (agent/tools/endlaDb.ts) and PathFilterControls write SqlFilter
 * objects here; FilterBarProvider instances consume and remove commands
 * matching their modelName.
 */

import type { SqlFilter } from "@/endlaFunctions/customTypings/ecTypes";
import { atom } from "jotai";

export type PendingSqlFilterCommand =
  | (SqlFilter & { _remove?: false })
  | { _remove: true; uuid: string; model: string };

export const pendingSqlFilterCommandsAtom = atom<PendingSqlFilterCommand[]>([]);
